import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

const localLab = process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_TROUBLESHOOTING_LAB === "1" &&
  ["localhost", "127.0.0.1", "::1", "[::1]"].includes(window.location.hostname);

if (localLab) {
  // Do not import the connected bootstrap or Firebase in the isolated lab.
  import("./components/troubleshooting/TroubleshootingLab").then(({default: Lab}) => {
    ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<React.StrictMode><Lab /></React.StrictMode>);
  });
} else {
  void import("./bootstrap");
}
